import { forwardRef } from 'react';
import { NumericFormat } from 'react-number-format';

const NumberFormatInputUI = forwardRef(function NumberFormatInputUI(props, ref) {
  const { onChange, onValueChange, name, ...other } = props;

  return (
    <NumericFormat
      {...other}
      getInputRef={ref}
      thousandSeparator=" "
      decimalSeparator=","
      valueIsNumericString
      onValueChange={(values, sourceInfo) => {
        if (onValueChange) {
          onValueChange(values, sourceInfo);
          return;
        }

        onChange({
          target: {
            name,
            value: values.floatValue ?? null,
          },
        });
      }}
    />
  );
});

export default NumberFormatInputUI;
